$(function () {
    // @variables ------------------------------------------------------------------------------------------------------
    var $modal_dialog_model_b = $('#modal-dialog-model-b'),
        $modal_dialog_referer = $('#modal-dialog-referer')

    // @initialization -------------------------------------------------------------------------------------------------
    if ($modal_dialog_model_b.length) {
        $modal_dialog_model_b.modal('show')
        $modal_dialog_model_b.on('hidden.bs.modal', function () {
            sendData({
                action: 'hide modal dialog model b',
            })
        })
    }

    if ($modal_dialog_referer.length) {
        $modal_dialog_referer.modal({
            show: true,
            keyboard: false,
        })
        $modal_dialog_referer.on('hide.bs.modal', function () {
            return false
        })
    }

    // @functions ------------------------------------------------------------------------------------------------------
    function sendData(data) {
        return $.ajax({
            url: '/' + BB_DIR_WEBROOT + '/index.php/tools/packages/model_b/ajax.php',
            data: data,
            type: 'GET',
            dataType: 'html',
        })
    }

    // @events ---------------------------------------------------------------------------------------------------------
    $(document).on('click', '.btn-page-dst', function (eventObj) {
        var href = $(this).attr('href')

        eventObj.preventDefault()

        sendData({
            action: 'set session modal dialog model b',
        }).done(function () {
            window.location = href
        })
    })
})
